export enum ComponentName {
  CardCheck = 'Card Check',
  CardQuote = 'Card Quote'
}